import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLemonadeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 90,
	height: 89,
	viewBox: "0 0 90 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6.5,
			y: 5.05469,
			width: 78,
			height: 78.8864,
			rx: 39,
			fill: "#FFF8D5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.5823 54.8666C86.7088 62.8018 82.6918 70.0639 76.9736 75.8536C71.2553 81.6432 64.0575 85.7358 56.1725 87.6807C50.9586 88.96 45.5619 89.3126 40.2269 88.7225C29.4852 87.4607 19.55 82.372 12.2249 74.3802C4.83159 66.3811 0.654578 55.9119 0.501851 44.9981C0.427983 36.8681 2.5658 28.8721 6.68468 21.873C10.8036 14.8739 16.7471 9.13742 23.8739 5.28259C28.5989 2.76953 33.732 1.12232 39.0324 0.418152C44.3275 -0.297757 49.7057 -0.0932286 54.9317 1.02274C60.1777 2.1374 65.1749 4.21192 69.6735 7.1428C78.7961 13.077 85.4426 22.158 88.36 32.6742C88.5545 33.4183 88.7304 34.1438 88.9156 34.8507C89.0562 35.5452 89.1582 36.2469 89.2212 36.9528C89.2953 37.6224 89.3509 38.2735 89.4064 38.8873C89.4064 39.185 89.4064 39.4826 89.4712 39.7709C89.536 40.0593 89.4712 40.3383 89.4712 40.6081C89.3601 42.7473 89.1101 44.1425 88.7582 44.3285C88.4063 44.5145 88.0174 43.51 87.6748 41.7521C87.5822 41.3056 87.4989 40.822 87.4248 40.2918C87.3507 39.7616 87.1748 39.2129 87.0636 38.6176C86.9525 38.0224 86.8044 37.3899 86.684 36.7574C86.6192 36.4319 86.5729 36.097 86.4895 35.7529L86.2117 34.7298C86.1006 34.274 85.971 33.7997 85.8506 33.3253C83.2439 23.3227 77.1442 14.5947 68.6642 8.7333C64.4268 5.78773 59.6732 3.67335 54.6539 2.50158C49.618 1.33457 44.4135 1.09192 39.2917 1.78538C28.9416 3.16258 19.4786 8.37798 12.762 16.4067C9.42639 20.3638 6.8262 24.891 5.0855 29.7723C3.35299 34.6483 2.49094 39.7932 2.53902 44.9703C2.64903 55.4303 6.54251 65.4931 13.4935 73.2827C20.4563 81.1189 30.077 86.0667 40.4769 87.1599C45.6171 87.6463 50.8024 87.2149 55.7928 85.8856C60.746 84.5434 65.4191 82.3193 69.5902 79.3191C78.012 73.3137 83.9437 64.4096 86.258 54.2992C86.6284 53.0343 86.7951 51.7786 87.0266 50.6346C87.1377 50.0579 87.2581 49.5091 87.3785 48.9883C87.4989 48.4674 87.5266 47.9838 87.6192 47.5281C87.9155 45.7237 88.2674 44.5145 88.61 44.3843C88.9526 44.2541 89.2027 45.2307 89.3416 46.9606C89.4948 49.2891 89.3233 51.6277 88.8323 53.9086L88.7767 54.1504L88.5823 54.8666Z",
			fill: "#173962"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 44.5017,
			cy: 60.1458,
			rx: 23.8142,
			ry: 5.59111,
			fill: "#002864",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M58.5906 31.6379C59.6721 33.9275 59.2753 36.7528 57.4002 38.6492C55.5252 40.5456 52.7317 40.9469 50.4679 39.8532C49.3864 37.5637 49.7832 34.7383 51.6583 32.8419C53.5333 30.9456 56.3268 30.5443 58.5906 31.6379Z",
			fill: "#6ED278"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.618 31.6379L59.3121 31.3026C59.2362 31.142 59.1083 31.0126 58.9495 30.9359L58.618 31.6379ZM50.4952 39.8532L49.8012 40.1886C49.877 40.3491 50.0049 40.4785 50.1637 40.5552L50.4952 39.8532ZM57.9239 31.9732C58.8693 33.9746 58.5211 36.4431 56.8836 38.0991L57.9715 39.1993C60.0842 37.0625 60.5296 33.8803 59.3121 31.3026L57.9239 31.9732ZM56.8836 38.0991C55.2463 39.7551 52.8057 40.1073 50.8268 39.1513L50.1637 40.5552C52.7124 41.7865 55.8588 41.336 57.9715 39.1993L56.8836 38.0991ZM51.1893 39.5179C50.2439 37.5165 50.5921 35.0481 52.2296 33.392L51.1417 32.2919C49.029 34.4286 48.5836 37.6108 49.8012 40.1886L51.1893 39.5179ZM52.2296 33.392C53.8669 31.7361 56.3076 31.3839 58.2864 32.3399L58.9495 30.9359C56.4008 29.7046 53.2545 30.1551 51.1417 32.2919L52.2296 33.392Z",
			fill: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M47.5953 23.2813C50.7504 24.4088 53.0109 27.4519 53.0109 31.0289C53.0109 34.606 50.7504 37.649 47.5953 38.7766C44.4402 37.649 42.1797 34.606 42.1797 31.0289C42.1797 27.4519 44.4402 24.4088 47.5953 23.2813Z",
			fill: "#6ED278"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.6226 23.2578L47.883 22.5294C47.7146 22.4692 47.5306 22.4692 47.3623 22.5294L47.6226 23.2578ZM47.6226 38.7532L47.3623 39.4816C47.5306 39.5418 47.7146 39.5418 47.883 39.4816L47.6226 38.7532ZM47.3623 23.9863C50.215 25.0058 52.2647 27.761 52.2647 31.0055L53.8118 31.0055C53.8118 27.0959 51.3405 23.765 47.883 22.5294L47.3623 23.9863ZM52.2647 31.0055C52.2647 34.25 50.215 37.0052 47.3623 38.0247L47.883 39.4816C51.3405 38.246 53.8118 34.9151 53.8118 31.0055L52.2647 31.0055ZM47.883 38.0247C45.0303 37.0052 42.9806 34.25 42.9806 31.0055L41.4334 31.0055C41.4334 34.9151 43.9048 38.246 47.3623 39.4816L47.883 38.0247ZM42.9806 31.0055C42.9806 27.761 45.0303 25.0058 47.883 23.9863L47.3623 22.5294C43.9048 23.765 41.4334 27.0959 41.4334 31.0055L42.9806 31.0055Z",
			fill: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.7009 57.1718C54.5872 52.2299 55.4802 44.5653 52.6801 37.5187C53.3332 36.6014 53.2518 35.3148 52.4359 34.4896C51.62 33.6645 50.3478 33.5821 49.4408 34.2426C42.4734 31.4107 34.8949 32.3139 30.0086 37.2557C25.1223 42.1975 24.2293 49.8621 27.0294 56.9087C26.3763 57.826 26.4577 59.1127 27.2736 59.9379C28.0895 60.763 29.3617 60.8454 30.2687 60.1848C37.2361 63.0167 44.8146 62.1136 49.7009 57.1718Z",
			fill: "#F6DD64"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.5815 33.2891C49.2807 41.6582 47.91 50.4548 42.1627 56.2674C39.7645 58.6928 36.8527 60.3475 33.6721 61.2541C39.6173 62.6215 45.6203 61.3199 49.7243 57.1693C54.6106 52.2274 55.5036 44.5629 52.7035 37.5162C53.3566 36.599 53.2752 35.3123 52.4593 34.4871C51.6434 33.662 50.3712 33.5797 49.4643 34.2401C48.5119 33.8531 47.5482 33.5358 46.5815 33.2891Z",
			fill: "#DFBF23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.7009 57.1718C54.5872 52.2299 55.4802 44.5653 52.6801 37.5187C53.3332 36.6014 53.2518 35.3148 52.4359 34.4896C51.62 33.6645 50.3478 33.5821 49.4408 34.2426C42.4734 31.4107 34.8949 32.3139 30.0086 37.2557C25.1223 42.1975 24.2293 49.8621 27.0294 56.9087C26.3763 57.826 26.4577 59.1127 27.2736 59.9379C28.0895 60.763 29.3617 60.8454 30.2687 60.1848C37.2361 63.0167 44.8146 62.1136 49.7009 57.1718Z",
			stroke: "#003B6F",
			strokeWidth: 1.54717,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.0876 37.3438C34.6968 38.0246 31.2513 41.5092 30.5781 45.9499",
			stroke: "white",
			strokeWidth: 1.54717,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.2923 50.2507C62.2923 58.0745 56.1542 61.5951 49.1392 61.5951C44.4578 61.5951 45.3394 56.5161 45.3394 50.2507C45.3394 43.9853 44.4578 38.9063 49.1392 38.9063C55.2773 38.9063 62.2923 41.2534 62.2923 50.2507Z",
			fill: "#F6DD64"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M62.0431 48.1484C61.0004 54.7062 54.236 57.6812 46.5933 57.6812C46.1041 57.6812 45.6661 57.6417 45.2742 57.5654C45.547 60.0287 46.4317 61.5931 49.0298 61.5931C56.0447 61.5931 62.1828 58.0724 62.1828 50.2486C62.1828 49.5038 62.1348 48.8046 62.0431 48.1484Z",
			fill: "#DFBF23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.2925 50.2507C62.2925 58.4656 55.8754 61.5951 48.5415 61.5951C43.6473 61.5951 44.569 56.5161 44.569 50.2507C44.569 43.9853 43.6473 38.9062 48.5415 38.9062C54.9586 38.9062 62.2925 42.0358 62.2925 50.2507Z",
			stroke: "#003B6F",
			strokeWidth: 1.54717,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 47.9825,
			cy: 50.2507,
			rx: 10.4434,
			ry: 11.3444,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 47.982,
			cy: 50.2473,
			rx: 8.12264,
			ry: 8.99732,
			fill: "#FFE361"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M47.6224 38.7109C47.5229 38.7109 47.4423 38.7985 47.4423 38.9065V46.8198C47.4423 47.2628 47.1265 47.6317 46.7484 47.8627C46.3414 48.1114 45.8195 48.2168 45.4154 47.9634L39.2084 44.0706C39.1222 44.0166 39.0121 44.0486 38.9624 44.1422L38.6023 44.8197C38.5526 44.9133 38.5821 45.0329 38.6682 45.0869L44.8672 48.9747C45.2885 49.239 45.4617 49.7536 45.4617 50.251C45.4617 50.7483 45.2885 51.263 44.8672 51.5272L38.6682 55.415C38.5821 55.469 38.5526 55.5887 38.6023 55.6822L38.9624 56.3598C39.0121 56.4533 39.1222 56.4854 39.2084 56.4314L45.4154 52.5385C45.8195 52.2851 46.3414 52.3906 46.7484 52.6393C47.1265 52.8703 47.4423 53.2391 47.4423 53.6822V61.5954C47.4423 61.7034 47.5229 61.791 47.6224 61.791H48.3426C48.442 61.791 48.5227 61.7034 48.5227 61.5954V53.6822C48.5227 53.2391 48.8385 52.8703 49.2166 52.6393C49.6236 52.3906 50.1455 52.2851 50.5496 52.5385L56.7567 56.4314C56.8428 56.4854 56.9529 56.4533 57.0026 56.3598L57.3628 55.6822C57.4125 55.5887 57.383 55.469 57.2969 55.415L51.0978 51.5272C50.6764 51.2629 50.5033 50.7483 50.5033 50.251C50.5033 49.7536 50.6764 49.239 51.0978 48.9748L57.2969 45.0869C57.383 45.0329 57.4125 44.9133 57.3628 44.8197L57.0026 44.1422C56.9529 44.0486 56.8428 44.0166 56.7567 44.0706L50.5496 47.9634C50.1455 48.2169 49.6236 48.1114 49.2166 47.8627C48.8385 47.6317 48.5227 47.2628 48.5227 46.8198V38.9065C48.5227 38.7985 48.442 38.7109 48.3426 38.7109H47.6224ZM47.9827 51.4245C48.5794 51.4245 49.063 50.8991 49.063 50.251C49.063 49.6028 48.5794 49.0774 47.9827 49.0774C47.386 49.0774 46.9023 49.6028 46.9023 50.251C46.9023 50.8991 47.386 51.4245 47.9827 51.4245Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 47.9825,
			cy: 50.2507,
			rx: 10.4434,
			ry: 11.3444,
			stroke: "#003B6F",
			strokeWidth: 1.54717,
			strokeLinejoin: "round"
		})
	]
});
export default SvgLemonadeIcon;
